import { render, staticRenderFns } from "./WechatPill.vue?vue&type=template&id=eb7523a4"
import script from "./WechatPill.vue?vue&type=script&lang=js"
export * from "./WechatPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports